import * as React from "react";
import {FBFieldWithPriceBase, FBFieldWithPriceBaseState} from "FormBuilder/Fields/Core/FBFieldWithPriceBase";
import {PriceTypeEnum} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Options";
import {FBFieldBaseProps} from "FormBuilder/Fields/Core/FBFieldBase";
import {GetModel} from "FormBuilder/Events/GetModel";
import {FieldTypeEnum} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {GetFieldOptions} from "FormBuilder/Events/GetFieldOptions";
import {GetField} from "FormBuilder/Events/GetField";
import {EventManager} from "shared/core/Events/EventManager";
import {FBSwitchModel} from "./FBSwitch.Model";
import {FBSwitchOptions} from "./FBSwitch.options";



import {IconOrImage} from "FormBuilder/Fields/Core/Interfaces/IconOrImage";
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";
import {IconOrImageDisplayer} from "FormBuilder/Fields/Core/SubComponents/IconOrImageDisplayer";

let switchfield=require('react-switch').default;


let library=null;
let context=null;
declare let require:any;
if(require.context!=null) {
    let context = require.context("./", true, /(?<!test)\.tsx?$/);
    let library: any = {};
    for (let key of context.keys()) {
        library[key.substring(0, key.lastIndexOf('.'))] = key;
    }


}
export default function (libraryName) {
    libraryName = './' + libraryName.substring(8);//removed /InternalShared and adding ./

    if (library[libraryName] == null)
        throw 'Library not found ' + libraryName;

    return context(library[libraryName]);


}


export class FBSwitch extends FBFieldWithPriceBase<FBTextFieldProps,FBTextFieldState>{

    static defaultProps: Partial<FBTextFieldProps> = {

    };

    constructor(props: FBTextFieldProps) {
        super(props);


    }

    componentWillReceiveProps(nextProps: Readonly<FBTextFieldProps>, nextContext: any): void {

        if(this.Model.Parent.IsDesign)
        {
            this.Model.Checked=this.Model.Options.Checked;
            this.Model.Quantity=this.Model.Options.QuantityDefaultValue==''?"": this.Model.ParseNumber(this.Model.Options.QuantityDefaultValue);
        }

    }

    SubRender() {
        if(this.props.Model.Options.ShowQuantitySelector&&this.props.Model.Options.PriceType!=PriceTypeEnum.quantity)
        {
            return(
            this.props.Model.Options.QuantityPosition == "bottom" || this.props.Model.Options.QuantityPosition == "right" ?
                <React.Fragment>
                    {this.GetInput(this.props.Model.Options.QuantityPosition)}
                    {this.GetQuantityInput()}

                        {this.GetPriceOrRequiredBox()}

                </React.Fragment>:
                <React.Fragment>
                    {this.GetQuantityInput()}
                    {this.GetInput(this.props.Model.Options.QuantityPosition)}

                        {this.GetPriceOrRequiredBox()}

                </React.Fragment>
            )
        }
        return(
            <React.Fragment>
                {this.GetInput('')}

                    {this.GetPriceOrRequiredBox()}

            </React.Fragment>
        )


    }






    GetQuantityInput(){
        return(
            <div className={'rnTextFieldQuantity '+ this.props.Model.Options.QuantityPosition}>
                <div className={'rednaoLabel'}>
                    <label style={{fontWeight:'bold'}}>{this.props.Model.Options.QuantityLabel}</label>
                </div>
                <input className={'rnInputQuantity'} placeholder={this.Model.Options.QuantityPlaceholder} style={{width:'100%'}} type={'text'} value={this.Model.Quantity}
                       onChange={x=>{this.Model.Quantity=this.Model.ParseNumber(x.target.value as any);this.Model.Refresh()}}/>
            </div>

        )
    }

    GetInput(additionalClassNames:string){
        return (
            <div className={'rnTextFieldInput '+ additionalClassNames}>
                {this.GetLabel()}
                {React.createElement(switchfield,
                    {
                        checked:this.Model.Checked,
                        onChange:x=>this.OnChange(x),
                        checkedIcon:<IconOrImageDisplayer icon={this.Model.Options.CheckedIcon}/>,
                        uncheckedIcon:<IconOrImageDisplayer icon={this.Model.Options.UnCheckedIcon}/>,
                        offColor:this.Model.Options.UnCheckColor,
                        onColor:this.Model.Options.CheckColor
                    })}
            </div>

        );
    }






    private OnChange(x: boolean) {
        if(this.Model.Checked)
            this.Model.RemoveError('required');

        this.Model.Checked=x;
        this.Model.Quantity=this.Model.Checked&&this.Model.Quantity==0?1:this.Model.Quantity;
        this.Model.FireValueChanged();


    }

}
//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FBTextFieldProps extends FBFieldBaseProps{
    Model:FBSwitchModel;
}

interface FBTextFieldState extends FBFieldWithPriceBaseState{

}





EventManager.Subscribe(GetModel,(event)=>{
    if(event.Options.Type==FieldTypeEnum.Switch)
        return new FBSwitchModel(event.Options as FBSwitchOptions,event.parent).Initialize(event.PreviousData);
});


EventManager.Subscribe(GetFieldOptions,(event)=>{
    if(event.Type==FieldTypeEnum.Switch)
        return new FBSwitchOptions();
});

EventManager.Subscribe(GetField,(event)=>{
    if(event.Model.Options.Type==FieldTypeEnum.Switch)
        return <FBSwitch Model={event.Model as FBSwitchModel} />
});

//#endregion "My Region"